import React from 'react';
import PropTypes from 'prop-types';
import slug from 'constants/slug';
import styled from 'styled-components';
import { Hotkey, Hotkeys } from '@blueprintjs/core';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import Clearfix from 'components/elements/clearfix';
import LookuplistSelect from 'components/elements/select-lookuplist-items';
import { HotkeysTarget, Icon, InputGroup, Intent } from '@blueprintjs/core';
import { Col, Row } from 'reactstrap';
import { IconNames } from '@blueprintjs/icons';
import createForm from 'rc-form/lib/createForm';
import { get } from 'lodash';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
  cursor: pointer;
`;

@HotkeysTarget
class SpeciesList extends BaseListContainer {
  static propTypes = {
    biodiversityID: PropTypes.string,
    getDetail: PropTypes.func,
  };

  constructor(props) {
    const funcApi = {
      getList: props.getList,
    };
    const columns = [
      {
        dataField: 'SpeciesName',
        text: 'Tên loài',
        formatter: (cell, row) => {
          return (
            <NameContainer onClick={() => props.getDetail(row._id)}>
              {cell ? cell.Name : ''}
            </NameContainer>
          );
        },
      },
      {
        dataField: 'SpeciesType',
        text: 'Mức độ bảo tồn',
        formatter: (cell) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'LocalName',
        text: 'Tên địa phương',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'ScienceName',
        text: 'Tên khoa học',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Surname.Name',
        text: 'Họ',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Set.Name',
        text: 'Bộ',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Areas',
        text: 'Vùng phân bố',
        formatter: (cell) => {
          return (
            <div>
              {cell
                .sort(
                  (a, b) =>
                    new Date(b.AddedOn).getTime() -
                    new Date(a.AddedOn).getTime()
                )
                .map((item) => (
                  <div>{item.Area}</div>
                ))}
            </div>
          );
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.SPECIES.CREATE}?biodiversityID=${props.biodiversityID}`,
      'biodiversity',
      null,
      false
    );

    this.state = {
      ...this.state,
      dataList: this.props.dataList || [],
      isLoading: true,
    };
  }

  handelSearch = () => {
    const { form } = this.props;

    const values = form.getFieldsValue();
    const params = {
      search: get(values, 'SpeciesName'),
      SpeciesType: get(values, 'SpiciesType.value'),
      Surname: get(values, 'Surname.value'),
      Set: get(values, 'Set.value'),
    };
    super.handelSubmitSearch(params);
  };

  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.handelSearch}
        />
      </Hotkeys>
    );
  }
  renderSearchContainer() {
    const { form } = this.props;
    return (
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>Tìm kiếm</span>
              <Clearfix width={8} />
              <div style={{ flex: 1 }}>
                {form.getFieldDecorator('SpeciesName')(
                  <InputGroup placeholder='Tên loài' />
                )}
              </div>
              <Clearfix width={8} />
              <Icon
                icon={IconNames.SEARCH}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                onClick={this.handelSearch}
              />
            </div>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LookuplistSelect
              label='Mức độ bảo tồn'
              lookupListId='SpiciesType'
              fieldForm={{ form, name: 'SpiciesType' }}
            />
          </Col>
          <Col xs={4}>
            <LookuplistSelect
              label='Họ'
              lookupListId='Surname'
              fieldForm={{ form, name: 'Surname' }}
            />
          </Col>
          <Col xs={4}>
            <LookuplistSelect
              label='Bộ'
              lookupListId='Set'
              fieldForm={{ form, name: 'Set' }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(SpeciesList);



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/SpeciesList/index.js